export default __webpack_public_path__ + "assets/images/bb647a792a695ec2c4049bda29a25623.png";